import { render, staticRenderFns } from "./ModalScheduleAlert.vue?vue&type=template&id=2a167cd5&scoped=true"
import script from "./ModalScheduleAlert.vue?vue&type=script&lang=js"
export * from "./ModalScheduleAlert.vue?vue&type=script&lang=js"
import style0 from "./ModalScheduleAlert.vue?vue&type=style&index=0&id=2a167cd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a167cd5",
  null
  
)

export default component.exports